import type { MenuDefinition } from '@/shared/layouts/menu/types';
import type { TenantMenuContext } from '../../../../types';
import { readStoredMenu } from '../../../services/menuStore';

/**
 * The Keilog sidebar.
 *
 * One tree for every account. `/me/permissions` publishes the server-filtered
 * snapshot before this synchronous factory runs; core never learns that Keilog
 * has permissions at all.
 */
export function getKeilogClinicMenu(_context: TenantMenuContext): MenuDefinition {
  return readStoredMenu();
}
